import {IAmplitudePhoneVerificationContext} from "../../user/tracking/track_amplitude_phone_verified";
import {SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export const SEMANTIC_SEARCH_PHONE_VERIFICATION_CONTEXT: IAmplitudePhoneVerificationContext = {
    location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
    phoneVerifyPlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT
};
import {IAmplitudePhoneVerificationContext} from "../../user/tracking/track_amplitude_phone_verified";
import {SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export const SEMANTIC_SEARCH_PHONE_VERIFICATION_CONTEXT: IAmplitudePhoneVerificationContext = {
    location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
    phoneVerifyPlacement: SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT
};
